export const COMPANY_TYPE_LABELS = {
  ETC: '기타',
  FINANCE: '금융권',
  FOREIGN: '외국계기업',
  HOSPITAL: '병원',
  MAJOR: '대기업',
  MEDIUM: '중견기업',
  ORGANIZATION: '비영리단체/협회/재단',
  PUBLIC: '공공기관/공기업',
  SMALL_MEDIUM: '중소기업',
  STARTUP: '스타트업',
  STUDENT_ASSOCIATION: '동아리/학생자치단체',
} as const
